import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import Icon from '../AppIcon';

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  variant = 'destructive',
  hideCancel = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-100 flex items-center justify-center bg-black/50 p-4"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
    >
      <div className="bg-card rounded-lg border border-border shadow-elevation-lg max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertTriangle" size={20} className="text-destructive" />
          </div>
          <div>
            <h2 id="confirm-dialog-title" className="text-lg font-semibold text-foreground">
              {title ?? t('common.confirm')}
            </h2>
            <p className="text-sm text-muted-foreground mt-1">{message}</p>
          </div>
        </div>
        <div className="flex gap-3 justify-end">
          {!hideCancel && (
            <Button variant="outline" size="default" onClick={onClose}>
              {cancelText ?? t('common.cancel')}
            </Button>
          )}
          <Button variant={variant} size="default" onClick={onConfirm}>
            {confirmText ?? t('common.confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
